import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import SortObject from "../../types/SortObject";
import ContractorModel from "../../viewModels/Contractors/ContractorModel";
import createMessageModalSlice from "../../widgets/CreateMessageModal/reducer";
import editContractorDrawerSlice from "../../widgets/EditContractorDrawer/reducer";
import { MessageDataConverter } from "../../viewModels/Message/MessageModel";
import type { ContractorTableFilters } from "./utils/contractorTableFilters";

export type ContractorsFilters = ContractorTableFilters & { countryId?: number[] | null; responsibleId?: number[] | null };

const initialState: {
  loading: boolean;
  loadingData: boolean;
  error: boolean;
  contractors: Array<ContractorModel>;
  total: number;
  pageSize: number;
  page: number;
  sort?: SortObject;
  searchFilterValue: string;
  filters: ContractorsFilters;
  contractorIdToEdit?: number;
} = {
  loading: true,
  loadingData: true,
  error: false,

  contractors: undefined!,
  total: undefined!,
  pageSize: 10,
  page: 1,

  searchFilterValue: "",
  filters: {},
};

const contractorsSlice = createSlice({
  name: "contractors",
  initialState,
  reducers: {
    loadContractors(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadContractorsSuccess(state, action: PayloadAction<{ contractors: Array<ContractorModel>; total: number }>) {
      const { contractors, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.error = false;
      state.contractors = contractors;
      state.total = total;
    },
    loadContractorsError(state) {
      state.error = true;
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(
      state,
      action: PayloadAction<{ page: number; pageSize: number; sort?: SortObject; filters: ContractorsFilters; pattern?: string }>,
    ) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.filters = action.payload.filters;
      state.error = false;
      state.searchFilterValue = action.payload.pattern || "";
      state.loadingData = true;
    },
    changeSearchFilterValue(state, action: PayloadAction<string>) {
      state.searchFilterValue = action.payload;
    },
    search(state) {
      state.loadingData = true;
      state.page = 1;
    },

    deleteContractorService(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
  },
  extraReducers(builder) {
    builder.addCase(createMessageModalSlice.actions.createMessageSuccess, (state, action) => {
      const contractorIndex = (state.contractors || []).findIndex((x) => x.id === action.payload.contractorId);
      if (contractorIndex !== -1) {
        state.contractors[contractorIndex] = {
          ...state.contractors[contractorIndex],
          messages: [MessageDataConverter.convertMessage(action.payload), ...state.contractors[contractorIndex].messages],
        };
      }
    });

    builder.addCase(editContractorDrawerSlice.actions.updateContractorSuccess, (state, action) => {
      const contractorIndex = (state.contractors || []).findIndex((x) => x.id === action.payload.id);
      if (contractorIndex !== -1) {
        state.contractors[contractorIndex] = action.payload;
      }
    });
  },
});

export default contractorsSlice;
